import React from 'react';
import DOMPurify from 'dompurify';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    signature: string;
    onRemove: () => void;
}

/** The signature as it will be appended, shown under the reply being written. */
const EmailSignaturePreview = ({ signature, onRemove }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="relative border-t border-gray-300 bg-gray-200 px-3 py-2">
            {/* Padded on the end side so a long line never runs under the
                button, in either text direction. */}
            <div
                className="pe-7 text-sm text-gray-600"
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(signature),
                }}
            />
            <IconButton
                type="button"
                // IconButton names an icon-only button from its tooltipLabel.
                tooltipLabel={i18next.t('premadeAnswer.removeSignature')}
                onClick={onRemove}
                className="absolute end-1 top-1 flex h-6 w-6 items-center justify-center rounded text-gray-600"
            >
                <Icon iconKey="close" size="1rem" />
            </IconButton>
        </div>
    );
};

export default EmailSignaturePreview;
